const button = document.getElementsByClassName('js-more-button')[0] as HTMLElement;
const infos = document.querySelectorAll<HTMLElement>('.js-viewed .js-apartment_info');

Array.from(infos)
  .slice(2, infos.length)
  .forEach(element => {
    element.classList.add('is-hidden');
  });

button.addEventListener('click', () => {
  infos.forEach(element => {
    element.classList.remove('is-hidden');
  });
  button.classList.add('is-hidden');
});
